import { lazy } from 'react';
export const TraderAccounts = lazy(() => import('@/TraderPortal/TraderAccounts'));
export const TraderInventory = lazy(() => import('@/TraderPortal/Inventory'));
export const TraderUpload = lazy(() => import('@/Portal/TraderUpload'));
export const OpsTraderList = lazy(() => import('@/Ops/OpsTraderList'));
